<template>
  <Modal @close="cancelStoreModal()">
    <div class="p-modal__content__header">
      {{ $t('labels.selectTargetStores') }}
    </div>
    <div class="p-modal__content__body">
      <FilterItem
        :list="allStores"
        :list-type="'store'"
        value-key="uuid"
        store-name="companiesInvitations"
        :head-text="$t('labels.selectAll')"
        filter-type="store_uuids"
      />
    </div>
    <div class="p-modal__content__footer">
      <div class="store-count-wap">
        {{ $t('labels.targetStoreCount') }}
        <span class="store-count">{{ selectedStoreCount }}</span>
        {{ $t('labels.storeCountUnit') }}
      </div>
      <div class="c-button c-button--right">
        <button
          class="c-button__item c-button__item--outline-cancel"
          @click.prevent="cancelStoreModal()"
        >
          {{ $t('labels.backSelectCondition') }}
        </button>
        <button
          class="c-button__item c-button__item--primary"
          @click.prevent="confirmStoreModal()"
        >
          {{ $t('labels.save') }}
        </button>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Modal from '../Modal.vue'
import FilterItem from '../FilterItem.vue'

export default {
  components: {
    Modal,
    FilterItem,
  },
  emits: ['back-filter-modal', 'close-store-modal'],
  computed: {
    ...mapState({
      companiesLocationStores: state => state.companiesLocationStores.data,
      formValues: state => state.companiesInvitations.formValues,
    }),
    allStores() {
      return this.companiesLocationStores.map(v => ({
        uuid: v.attributes.uuid,
        name: v.attributes.name
      }))
    },
    allStoreUuids() {
      return this.allStores.map(store => store.uuid)
    },
    selectedStoreCount() {
      return this.formValues.store_uuids.length
    },
  },
  created() {
    this.setFormValues({ store_uuids: this.allStoreUuids })
  },
  methods: {
    ...mapMutations({
      setFormValues: 'companiesInvitations/setFormValues',
    }),
    cancelStoreModal() {
      this.$emit('back-filter-modal')
    },
    confirmStoreModal() {
      this.$emit('close-store-modal', this.formValues.store_uuids)
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../stylesheets/biz_spa/foundation/_var.scss';
.p-modal {
  &__content {
    &__footer {
      padding: 12px 32px;
      border-top: 1px solid $color-base-c;
    }
  }
}
.store-count-wap {
  position: absolute;
  bottom: 5px;
  right: 270px;
}
.store-count {
  margin: 0 5px;
  font-size: 30px;
  font-weight: 700;
  color: $color-accent-primary;
}
</style>